import { useEffect } from 'react';
import React, { useState } from 'react';

import { IBooking, IDelta, ITextBlock } from '@homeporter/types';

import QuillEditor from './QuillEditor';
import { StyledResults } from './styles';
import { QuillDeltaToHtmlConverter } from 'quill-delta-to-html';
import { marked } from 'marked';
import { formatMobileNumber, SIZE_WHITELIST } from '../../../../utils/helpers';
import { formatInTimeZone } from 'date-fns-tz';

const sizeMap = Object.fromEntries(
  SIZE_WHITELIST.map((v) => [v, `font-size:${v}`]),
);

interface TextBlockProps {
  index: number;
  textCard: ITextBlock;

  enableQuill: boolean;
  quillRef: React.RefObject<HTMLDivElement>;
  setSaveEnabled: (enabled: boolean) => void;
  booking: IBooking;
  description: string;
}

const TextBlock = ({
  textCard,

  enableQuill,
  quillRef,
  setSaveEnabled,
  booking,
  description,
}: TextBlockProps) => {
  const [rawHtml, setRawHtml] = useState<string>('');

  const replaceDynamicVariables = (html: string) => {
    const dynamicVariables = [
      {
        key: '{{session_title}}',
        value: booking?.title || '',
      },
      {
        key: '{{session_date}}',
        value: booking?.booking_date || '',
      },
      {
        key: '{{session_time}}',
        value:
          formatInTimeZone(
            new Date(booking.booking_date),
            booking?.timezone_name || 'UTC',
            'MMM dd yyyy HH:mm (zzz)',
          ) || '',
      },
      {
        key: '{{location}}',
        value:
          `${booking?.address}, ${booking?.city}, ${booking?.province}` || '',
      },
      {
        key: '{{address}}',
        value: booking?.address || '',
      },
      {
        key: '{{city}}',
        value: booking?.city || '',
      },
      {
        key: '{{province}}',
        value: booking?.province || '',
      },
      {
        key: '{{postalcode}}',
        value: booking?.postal_code || '',
      },
      {
        key: '{{mobile_phone}}',
        value: formatMobileNumber(booking?.mobile_number) || '',
      },
      {
        key: '{{email}}',
        value: booking?.payment?.user?.email || '',
      },
      {
        key: '{{notes}}',
        value: description || '',
      },
    ];

    return dynamicVariables.reduce((result, { key, value }) => {
      const regex = new RegExp(key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
      return result.replace(regex, value);
    }, html);
  };

  useEffect(() => {
    console.log('::::textCard: ', textCard);
    if (!textCard) {
      setRawHtml('');
      return;
    }

    const processPromptCard = async () => {
      if (!enableQuill) {
        if ((textCard.modified as IDelta)?.ops) {
          const ops = (textCard.modified as IDelta).ops;
          const converter = new QuillDeltaToHtmlConverter(ops, {
            inlineStyles: {
              size: sizeMap,
            },
          });
          setRawHtml(replaceDynamicVariables(converter.convert()));
        } else {
          const html = await marked(
            (textCard.modified || textCard.response) as string,
          );
          setRawHtml(replaceDynamicVariables(html));
        }
      }
    };

    processPromptCard();
  }, [textCard, enableQuill]);

  return (
    <StyledResults onClick={(e) => enableQuill && e.stopPropagation()}>
      {enableQuill ? (
        <QuillEditor
          quillRef={quillRef}
          card={textCard}
          setSaveEnabled={setSaveEnabled}
        />
      ) : (
        <div
          dangerouslySetInnerHTML={{
            __html: rawHtml,
          }}
        />
      )}
    </StyledResults>
  );
};

export default TextBlock;
